// removed by extract-text-webpack-plugin
module.exports = {"searchBar":"searchBar--1qj0L","formSearch":"formSearch--1pz4w","inputSearch":"inputSearch--31sQS","submitButton":"submitButton--2qKjF","clientNotReady":"clientNotReady--3zyko"};


/*****************
 ** WEBPACK FOOTER
 ** ./shared-components/SearchBar/component.scss
 ** module id = 612
 ** module chunks = 2 17
 **/